export enum ApplicationDeliveryType {
    FOREIGN_RETRIEVAL = 'FOREIGN_RETRIEVAL',
    PPA_RETRIEVAL = 'PPA_RETRIEVAL',
    CONSUL = 'CONSUL',
    STP_RETRIEVAL = 'STP_RETRIEVAL',
    COURIER_RETRIEVAL = 'COURIER_RETRIEVAL'
}

export enum MediatedIssuanceType {
    COMMON = 'COMMON',
    DISCOUNT = 'DISCOUNT'
}

export enum ApplicationType {
    COMBO = 'COMBO',
    CITIZEN_PASSPORT = 'CITIZEN_PASSPORT',
    ID_CARD = 'ID_CARD'
}

export enum ApplicantApplierRelationType {
    APPLICANT = 'APPLICANT',
    CHILD = 'CHILD',
    WARD = 'WARD'
}

export enum DocumentType {
    ID_CARD = 'idCard',
    CITIZEN_PASSPORT = 'citizenPassport'
}

export enum ValidDocumentType {
    CITIZEN_PASSPORT = 'CITIZEN_PASSPORT',
    ID_CARD = 'ID_CARD',
    ALIEN_PASSPORT = 'ALIEN_PASSPORT',
    RESIDENCE_CARD = 'RESIDENCE_CARD',
    SEAFARERS_DISCHARGE_BOOK = 'SEAFARERS_DISCHARGE_BOOK',
    CERTIFICATE_OF_SERVICE_ON_SHIPS = 'CERTIFICATE_OF_RECORD_OF_SERVICE_ON_SHIPS_CERTIFICATE',
    TEMPORARY_PASSPORT = 'TEMPORARY_PASSPORT',
    DIGITAL_ID = 'DIGITAL_ID_CARD',
    ADDITIONAL_PASSPORT = 'ADDITIONAL_PASSPORT',
    COMBO = 'COMBO'
}

export enum ExpeditedDepartment {
    POHJA_PREFEKTUURI_PINNA_TEENINDUS = '717',
    POHJA_PREFEKTUURI_TAMMSAARE_TEENINDUS = '783'
}

export const EXPEDITED_PLACE_OF_ISSUES: Array<string> = Object.values(ExpeditedDepartment)

export const ADULT_AGE = 18

export const AUTHORIZED_PERSON_MIN_AGE = 15

export const APPLICANT_MIN_AGE = 15

export enum ApplicationValidationFieldName {
    CONFIRMED_CONDITIONS = 'confirmedConditions',
    DISABILITY_CONFIRMATION = 'applicant.disabled',
    NOTES = 'application.notes'
}

export enum BiometryValidationFieldName {
    PHOTO = 'biometry.photo',
    SIGNATURE = 'biometry.signature'
}

export enum IdCardValidationFieldName {
    REASON = 'idCard.reason',
    DELIVERY_TYPE = 'idCard.delivery.type',
    DELIVERY_LOCATION = 'idCard.delivery.location',
    AUTHORIZED_FIRST_NAME = 'application.idCard.authorizedPerson.firstName',
    AUTHORIZED_LAST_NAME = 'application.idCard.authorizedPerson.lastName',
    AUTHORIZED_PERSON_CODE = 'application.idCard.authorizedPerson.personCode'
}

export enum CitizenPassportValidationFieldName {
    REASON = 'citizenPassport.reason',
    DELIVERY_TYPE = 'citizenPassport.delivery.type',
    REASON_EXPLANATION = 'citizenPassport.reason.explanation',
    DELIVERY_LOCATION = 'citizenPassport.delivery.location',
    COURIER_DELIVERY_COUNTRY='citizenPassport.courier.country',
    COURIER_DELIVERY_CITY='citizenPassport.courier.city',
    COURIER_DELIVERY_POSTAL_CODE='citizenPassport.courier.postal.code',
    AUTHORIZED_FIRST_NAME = 'application.citizenPassport.authorizedPerson.firstName',
    AUTHORIZED_LAST_NAME = 'application.citizenPassport.authorizedPerson.lastName',
    AUTHORIZED_PERSON_CODE = 'application.citizenPassport.authorizedPerson.personCode'
}

export enum ApplicantValidationFieldName {
    BIRTH_COUNTRY = 'applicant.birthCountry'
}

export enum ContactValidationFieldName {
    EMAIL = 'application.contact.email',
    PHONE_NUMBER = 'application.contact.phoneNumber',
    ADDRESS_CITY = 'application.contact.address.city',
    ADDRESS_STREET = 'application.contact.address.street',
    ADDRESS_COUNTRY = 'application.contact.address.country',
    ADDRESS_ADS_ADR_ID = 'application.contact.address.adsAdrId',
    ADDRESS_POSTAL_CODE = 'application.contact.address.postalCode',
    ADDRESS_STATE_OR_PROVINCE_OR_COUNTY = 'application.contact.address.stateOrProvinceOrCounty',
    ADDRESS_NOTES = 'application.contact.address.notes'
}

export const validatorIds: Record<string, string> = {
    [ApplicationValidationFieldName.CONFIRMED_CONDITIONS]: 'confirmed-conditions',
    [ApplicationValidationFieldName.DISABILITY_CONFIRMATION]: 'applicant-disabled',

    [BiometryValidationFieldName.PHOTO]: 'biometry-photo',
    [BiometryValidationFieldName.SIGNATURE]: 'biometry-signature',

    [IdCardValidationFieldName.REASON]: 'idCard-reason',
    [IdCardValidationFieldName.DELIVERY_LOCATION]: 'idCard-delivery-location',
    [IdCardValidationFieldName.AUTHORIZED_FIRST_NAME]: 'idCard-authorizedPerson-firstName',
    [IdCardValidationFieldName.AUTHORIZED_LAST_NAME]: 'idCard-authorizedPerson-lastName',
    [IdCardValidationFieldName.AUTHORIZED_PERSON_CODE]: 'idCard-authorizedPerson-personCode',

    [CitizenPassportValidationFieldName.REASON]: 'citizenPassport-reason',
    [CitizenPassportValidationFieldName.REASON_EXPLANATION]: 'citizenPassport-reason-explanation',
    [CitizenPassportValidationFieldName.DELIVERY_LOCATION]: 'citizenPassport-delivery-location',
    [CitizenPassportValidationFieldName.COURIER_DELIVERY_COUNTRY]: 'citizenPassport-courier-country',
    [CitizenPassportValidationFieldName.COURIER_DELIVERY_CITY]: 'citizenPassport-courier-city',
    [CitizenPassportValidationFieldName.COURIER_DELIVERY_POSTAL_CODE]: 'citizenPassport-courier-postal-code',
    [CitizenPassportValidationFieldName.AUTHORIZED_FIRST_NAME]: 'citizenPassport-authorizedPerson-firstName',
    [CitizenPassportValidationFieldName.AUTHORIZED_LAST_NAME]: 'citizenPassport-authorizedPerson-lastName',
    [CitizenPassportValidationFieldName.AUTHORIZED_PERSON_CODE]: 'citizenPassport-authorizedPerson-personCode',

    [ApplicantValidationFieldName.BIRTH_COUNTRY]: 'applicant-birthCountry',

    [ContactValidationFieldName.EMAIL]: 'contact-email',
    [ContactValidationFieldName.PHONE_NUMBER]: 'contact-phone-number',
    [ContactValidationFieldName.ADDRESS_CITY]: 'contact-address-city',
    [ContactValidationFieldName.ADDRESS_STREET]: 'contact-address-street',
    [ContactValidationFieldName.ADDRESS_COUNTRY]: 'contact-address-country',
    [ContactValidationFieldName.ADDRESS_ADS_ADR_ID]: 'contact-address-ads-adr-id',
    [ContactValidationFieldName.ADDRESS_POSTAL_CODE]: 'contact-address-postal-code',
    [ContactValidationFieldName.ADDRESS_STATE_OR_PROVINCE_OR_COUNTY]: 'contact-address-state-or-province-or-county',
    [ContactValidationFieldName.ADDRESS_NOTES]: 'contact-address-notes'
}

export enum ErrorMessageKeys {
    FINGERPRINTS_NOT_FOUND = 'errors.request.biometry.fingerprints.not.found',
    PERSON_ALIVE_UNDEFINED = 'errors.request.person.alive.undefined',
    PERSON_INVALID_CITIZENSHIP = 'errors.request.person.invalid.citizenship.general',
    PERSON_INVALID_EU_CITIZENSHIP = 'errors.request.person.invalid.citizenship.eu'
}

export enum Urls {
    PPA_DEPARTMENTS = 'https://www.politsei.ee/et/asukohad/teenindused',
    PPA_FOREIGNER_SELF_SERVICE = 'https://etaotlus.politsei.ee/vid/',
    PPA_E_RESIDENT = 'https://eresident.politsei.ee/'
}
